import { Button } from '@dev-spendesk/grapes';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { getHelpCenterBase } from 'src/core/common/utils/help-center/getHelpCenterBase';
import { routeFor, routes } from 'src/core/constants/routes';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

export const PayableRulesFilters = ({
  openModal,
}: {
  openModal: () => void;
}) => {
  const { t, activeLanguage } = useTranslation('global');
  const companyId = useCompanyId();
  const history = useHistory();

  const helpCenterLink = `${getHelpCenterBase({
    lang: activeLanguage,
  })}articles/11100945`;

  return (
    <>
      <div className="mb-16 flex items-center justify-between gap-16">
        <div className="placeholder-for-filter flex items-center gap-8">
          <h2 className="heading-l">
            {t('bookkeep.integrations.settings.sectionRuleBasedAutomation')}
          </h2>
        </div>
        <div className="flex items-center gap-8">
          <Button
            onClick={() => {
              window.open(helpCenterLink, '_blank', 'noopener,noreferrer');
            }}
            variant="tertiaryNeutral"
            text={t('bookkeep.integrations.settings.payableRules.helpCenter')}
            iconName="arrow-top-right-square"
            iconPosition="right"
          />
          <Button
            onClick={openModal}
            variant="secondaryNeutral"
            text={t('bookkeep.integrations.settings.payableRules.tour.label')}
          />
          <Button
            onClick={() => {
              history.push(
                routeFor(routes.COMPANY_ACCOUNTING_PAYABLE_RULES_SETUP.path, {
                  company: companyId,
                  payableRuleId: 'new',
                }),
              );
            }}
            variant="primaryBrand"
            text={t('bookkeep.integrations.settings.payableRules.create')}
          />
        </div>
      </div>
    </>
  );
};
